import { Container, Typography } from '@mui/joy'
import React from 'react'

export function PaymentProcessingPage() {
  return (
    <Container>
      <Typography level="h1" element="h1">Thanks for your subscription</Typography>
    </Container>
  )
}